import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { MilitaryHearingLossForm } from '../components/views/militaryHearingLossView/MilitaryHearingLossForm/MilitaryHearingLossForm'

function MilitaryHearingLossHome() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Military Hearing Loss" title="Add Client" />
                    <MilitaryHearingLossForm />
                </Page>
            </MainView>
        </div>
    )
}

export default MilitaryHearingLossHome
